import { Navigate, Outlet } from 'react-router';
import { RoleNames } from '../../config/role-names';
import { useSubscription } from '../../hooks/subscription/use-subscription';
import { usePermissions } from '../../hooks/use-permissions';
import { isGuardQuerySettling } from './guard-query-state';

interface SurveyAddonGuardProps {
  redirectTo?: string;
}

/**
 * Route guard for the Survey Builder & Runner add-on.
 * Mirrors DdtAddonGuard's shape but checks `SubscriptionInfo.surveyAddonEnabled`
 * with a bypass for the Consulente role, who always has access to Survey as
 * their core tool regardless of the per-tenant add-on toggle.
 */
export function SurveyAddonGuard({ redirectTo = '/home' }: SurveyAddonGuardProps) {
  const { surveyAddonEnabled, isPending, fetchStatus } = useSubscription();
  const {
    roleName,
    isPending: permissionsPending,
    fetchStatus: permissionsFetchStatus,
  } = usePermissions();
  if (
    isGuardQuerySettling({ isPending, fetchStatus }) ||
    isGuardQuerySettling({ isPending: permissionsPending, fetchStatus: permissionsFetchStatus })
  ) {
    return null;
  }
  if (roleName === RoleNames.CONSULTANT) {
    return <Outlet />;
  }
  if (!surveyAddonEnabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
